// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  api_base_url: "https://st-crm-api.narrativecommunities.com/api/",
  api_raw_base_url: "https://st-crm-api.narrativecommunities.com/",
  eta_api_base_url: "https://eta.st.fabrica.com.eg/api/",
  base_url: "https://st-crm.narrativecommunities.com",
  // api_base_url: "https://crm-api.narrativecommunities.com/api/",
  // api_raw_base_url: "https://crm-api.narrativecommunities.com/",
  // eta_api_base_url: "https://eta.st.fabrica.com.eg/api/",
  // base_url: "https://crm.narrativecommunities.com/",
  baseHREF: "/",
  firebase: {
    apiKey: "AIzaSyDl0UnkJ2QjsfDMVLluJgGCTJGVHf",
    authDomain: "biography-74a3e.firebaseapp.com",
    projectId: "biography-74a3e",
    storageBucket: "biography-74a3e.firebasestorage.app",
    messagingSenderId: "263100086321",
    appId: "1:263100086311:web:ada9900b2671ef1df03602",
    vapidkey:
      "BKkfN72Qv6KSS0di9l6qUxA31c1nPR1UW1Mt6OyRkonYKBr0tV8EuoVSezv9DOkJ1p9HhVoVmI5pas",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts